<template>
  <v-container class="checklist" fluid>
    <v-row>
      <v-col cols="12" class="body-2 grey--text text-left pb-0">
        <div>
          <v-breadcrumbs :items="routeItems" divider=">"></v-breadcrumbs>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12 title">
        Equipo: {{ $route.params.id }}
        <span class="caption">{{ $route.params.event | translateFilter }}</span>
      </v-col>
    </v-row>
    <prosic-state-images
      :event="$route.params.event"
      :checklistRef="checklistRef"
      :checklistType="checklistType"
      :queryPath="checklistPath"
      :path="checklistPath"
      :queryParams="queryParams"
      :accessToEdit="accessToEdit"
    ></prosic-state-images>
    <v-expansion-panels focusable>
      <v-expansion-panel
        v-for="(checklist, index) in !queryParams
          ? checklistArray
          : checklistQuery"
        :key="index"
        :readonly="!checklist.incidence && queryParams"
      >
        <v-expansion-panel-header
          :disabled="checklist.notApply || accessToEdit"
          class="pa-0 checklist-item"
          :class="
            checklist.checked
              ? 'expansion-panel-header--active'
              : 'expansion-panel-header'
          "
        >
          <v-container fluid class="pa-0" v-if="!queryParams">
            <v-row v-if="!checklist.notApply" no-gutters>
              <v-col
                align-self="center"
                class="px-1 py-4 checklist-item__not-apply text-center"
                cols="2"
                md="1"
                @click="
                  checklist.notApply = notApplyValidate(checklist.notApply)
                "
                >No aplica</v-col
              >

              <v-col cols="1" md="1" class="pl-2" align-self="center">
                <v-checkbox
                  :disabled="accessToEdit"
                  align-self="center"
                  hide-details
                  class="mt-1 mb-1 checklist-item__checkbox"
                  :ripple="false"
                  off-icon="radio_button_unchecked"
                  on-icon="radio_button_checked"
                  dense
                  @click.native.stop
                  height="0"
                  :input-value="checklistStatus(checklist.checked, index)"
                  :color="
                    checklistStatus(checklist.checked, index)
                      ? 'accent'
                      : 'primary'
                  "
                ></v-checkbox>
              </v-col>
              <v-col align-self="center" class="pa-3" cols="8" md="10">
                {{ checklist.title }}
              </v-col>
              <v-col align-self="center" cols="1">
                <v-icon color="accent" small>fas fa-plus</v-icon>
              </v-col>
            </v-row>
            <v-row class="pa-3" v-else no-gutters>
              <v-col
                align-self="center"
                class="pa-2"
                cols="11"
                md="11"
                @click.stop="checklist.notApply = !checklist.notApply"
                align="center"
                >No aplica este componente en este modelo</v-col
              >
              <v-col align-self="center" align="center" cols="1" md="1">
                <v-icon
                  class="checklist-item__icon"
                  color="gray"
                  dense
                  size="16"
                  @click.stop="checklist.notApply = !checklist.notApply"
                  >fas fa-plus</v-icon
                >
              </v-col>
            </v-row>
          </v-container>
          <v-container fluid class="pa-0" v-else>
            <v-row v-if="!checklist.notApply" no-gutters>
              <v-col cols="1" md="1" class="pl-2" align-self="center">
                <v-checkbox
                  align-self="center"
                  hide-details
                  class="mt-1 mb-1 checklist-item__checkbox"
                  :ripple="false"
                  off-icon="radio_button_unchecked"
                  on-icon="radio_button_checked"
                  dense
                  @click.native.stop
                  height="0"
                  :input-value="true"
                  :disabled="checklist.incidence != true"
                  :color="checklist.incidence == true ? 'accent' : 'primary'"
                ></v-checkbox>
              </v-col>
              <v-col align-self="center" class="pa-3" cols="8" md="10">
                {{ checklist.title }}
              </v-col>
              <v-col cols="3" class="text-right pr-4 pt-2">
                <v-icon color="accent" small v-if="checklist.incidence == true"
                  >fas fa-plus</v-icon
                >
              </v-col>
            </v-row>
          </v-container>
        </v-expansion-panel-header>
        <v-expansion-panel-content v-if="!checklist.notApply">
          <prosic-check-item
            :checklistRef="checklistRef"
            :checklistType="checklistType"
            :name="checklist.checklistName"
            :title="checklist.title"
            :index="index"
            :queryParams="queryParams"
            @update-incidence="checklistIncidence"
            :v-model="checklist.checked"
          ></prosic-check-item>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <ProsicFuelComponent
      :queryParams="queryParams"
      :accessToEdit="accessToEdit"
    />
    <ProsicHorometroComponent
      :queryParams="queryParams"
      :accessToEdit="accessToEdit"
      :path="checklistPath"
      :queryPath="checklistQueryPath"
    />
    <ProsicAddComponent v-if="!queryParams" :accessToEdit="accessToEdit" />
    <ProsicSignComponent
      :signChecklistDeliverer="
        allChecklistData ? allChecklistData.signedChecklistDeliverer : {}
      "
      :signChecklistReceiver="
        allChecklistData ? allChecklistData.signedChecklistReceiver : {}
      "
      v-if="queryParams"
    />
    <ProsicShareButton buttonTitle="COMPARTIR CHECKLIST" v-if="queryParams" />
    <v-row v-if="!queryParams">
      <v-col cols="12">
        <v-checkbox
          :disabled="accessToEdit"
          v-model="form.terms.value"
          align-self="center"
          hide-details
          class="mt-1 mb-1"
          :ripple="false"
          off-icon="radio_button_unchecked"
          on-icon="radio_button_checked"
          dense
          height="0"
        >
          <span slot="label">
            <a class="underline" @click="goContract()">
              <u>He leído</u>
            </a>
            y acepto los términos y condiciones de contrato.
          </span>
        </v-checkbox>
      </v-col>
    </v-row>
    <v-row v-if="!queryParams" justify="end">
      <v-col cols="12" md="4">
        <v-btn
          :disabled="!form.terms.value"
          block
          class="black--text"
          color="accent"
          @click="signChecklist()"
          >completar guardado</v-btn
        >
      </v-col>
    </v-row>
    <v-row v-else justify="end">
      <v-col cols="12" md="4">
        <v-btn block class="black--text" color="accent" @click="goBack()"
          >regresar</v-btn
        >
      </v-col>
    </v-row>
    <v-dialog v-model="imagesUploading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="subtitle-1">
          Subiendo imágenes, por favor espere
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
            height="8"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";
import ActualStateImages from "@/components/transfers/ActualStateImages";
import { errorMessage, showMessage } from "@/services/MessageService";
import CheckItem from "@/components/transfers/CheckItem";
import AddComponent from "@/components/damage/checklist/AddComponent";
import Checklist from "@/models/damage";
import { loaderDone, loaderStart } from "@/services/LoaderService";
import FuelComponent from "@/components/damage/checklist/FuelComponent";
import HorometroComponent from "@/components/damage/checklist/Horometro";
import SignComponent from "@/components/damage/checklist/SignComponent";
import ShareButton from "@/components/damage/checklist/ShareButton";

export default {
  data() {
    return {
      eventType: this.$route.params.event,
      checklistType: this.$route.params.event,
      typeAction: this.$route.params.action,
      productID: this.$route.params.productID,
      form: Checklist.getChecklistForm(),
      checklistArrayIncidence: [],
      analyticsIncidence: [],
      imagesUploading: false,
      accessToEdit: false,
      // :: Checklist
      checklistRef: null
    };
  },
  mounted() {
    if (!this.queryParams) {
      this.getTransferInfo();
    } else {
      try {
        this.getChecklistDataTransfer({
          id: this.$route.params.id,
          checklistType: this.checklistType,
          checklistArray: true
        });
      } catch (error) {
        errorMessage(
          "Ha ocurrido un error inesperado al conseguir la información del checklist"
        );
      }
    }
  },
  computed: {
    ...mapState("user", ["userAccess", "data"]),
    ...mapState("detail", ["dataOrder"]),
    ...mapState("checklistImages", ["itemsActualState"]),
    ...mapState("checklist", [
      "checklistArray",
      "checklistQuery",
      "eventRef",
      "productRef",
      "allChecklistData"
    ]),
    queryParams() {
      if (this.typeAction === "detalle") return true;
      else return false;
    },
    checklistPath() {
      return this.$route.params.id + "-" + this.$route.params.event;
    },
    routeItems() {
      let routeItems = [];
      let path = "";
      this.$router.currentRoute.fullPath.split("/").forEach(element => {
        path += element + "/";
        routeItems.push({
          text:
            element.length > 0
              ? element.charAt(0).toUpperCase() + element.substring(1)
              : "Inicio",
          disabled: false,
          href: path
        });
        if (routeItems[routeItems.length - 1].text === "Inicio")
          routeItems.splice(-1, 1);
      });
      return routeItems;
    }
  },
  components: {
    ProsicCheckItem: CheckItem,
    ProsicStateImages: ActualStateImages,
    ProsicAddComponent: AddComponent,
    ProsicFuelComponent: FuelComponent,
    ProsicHorometroComponent: HorometroComponent,
    ProsicSignComponent: SignComponent,
    ProsicShareButton: ShareButton
  },
  filters: {
    translateFilter(type) {
      if (type === "input") return "Entrada";
      else return "Salida";
    }
  },
  methods: {
    ...mapActions("user", ["updatesLogs"]),
    ...mapActions("transfers", [
      "getDetail",
      "saveChecklistSuccess",
      "updateOrderStatus",
      "saveActualStateImages"
    ]),
    ...mapActions("checklist", [
      "createChecklistTransferRefs",
      "getChecklistDataTransfer",
      "createChecklistRefs",
      "sendMail",
      "saveStatusDetail",
      "resetChecklist",
      "analyticsReport",
      "analyticsReportIncidence"
    ]),
    checklistIncidence(e) {
      this.analyticsIncidence.push(e);
      this.checklistArrayIncidence.push(e.index);
    },
    checklistStatus(check, index) {
      if (this.checklistArrayIncidence.includes(index)) {
        return true;
      }
    },
    goContract() {
      let routeData = this.$router.resolve({ name: "contrato" });
      window.open(routeData.href, "_blank");
    },
    async getTransferInfo() {
      try {
        const refCheckList = await this.createChecklistTransferRefs({
          id: this.$route.params.id,
          eventType: this.checklistType
        });
        this.checklistRef = refCheckList;
      } catch (error) {
        errorMessage("Lo sentimos, ha ocurrido un error inesperado");
      }
    },
    async signChecklist() {
      let checklistData = [];
      let analyticsReport = {};
      loaderStart();
      this.checklistArray.forEach(async (element, index) => {
        if (!this.checklistArrayIncidence.includes(index)) {
          checklistData.push({
            title: element.title,
            checked: true,
            incidence: false,
            notApply: element.notApply
          });
        }
      });
      if (Object.keys(this.itemsActualState).length > 0) {
        try {
          await this.saveChecklistSuccess({
            checklist: checklistData,
            checklistRef: this.checklistRef,
            checklistType: this.checklistType
          });
          this.imagesUploading = true;
          await this.saveActualStateImages({
            checklistRef: this.checklistRef,
            path: this.checklistPath
          });
          this.imagesUploading = false;
          await this.updatesLogs("save-checklist");
          await this.updateOrderStatus(this.$route.params.id);
          analyticsReport = {
            eventType: "traspasos",
            statusType: this.eventType,
            orderID: this.$route.params.id,
            userUid: this.data.uid
          };
        } catch (error) {
          errorMessage(
            "Ocurrió un error inesperado tratanto de guardar el checklist."
          );
        } finally {
          if (this.checklistArrayIncidence.length > 0) {
            analyticsReport.incidence = true;
            await this.analyticsReportIncidence(this.analyticsIncidence);
            let data = {
              number: this.dataOrder.id,
              path: this.$router.currentRoute.fullPath.replace(
                "guardar",
                "detalle"
              )
            };
            this.sendMail(data);
          }
          await this.analyticsReport(analyticsReport);
          if (this.eventType === "input") {
            this.$router.push({
              name: "signChecklistTransportistTransfer",
              params: {
                type: this.eventType,
                step: 1,
                eventType: "",
                path: this.$router.currentRoute.fullPath.replace(
                  "guardar",
                  "detalle"
                )
              }
            });
          } else {
            this.$router.push({
              name: "signChecklistReceptorTransfer",
              params: {
                type: this.eventType,
                step: 1,
                eventType: "",
                path: this.$router.currentRoute.fullPath.replace(
                  "guardar",
                  "detalle"
                )
              }
            });
          }
          showMessage({
            message: "La información se guardo correctamente",
            color: "success"
          });
          loaderDone();
        }
      } else {
        errorMessage(
          "No se puede guardar un checklist sin imágenes en el estado actual"
        );
        loaderDone();
      }
    },
    goBack() {
      this.$router.push({
        name: "transfer-detail",
        params: { id: this.$route.params.id }
      });
    },
    notApplyValidate(value) {
      if (this.accessToEdit) {
        return;
      } else {
        return !value;
      }
    }
  },
  beforeDestroy() {
    this.resetChecklist();
  }
};
</script>
<style scoped>
.checklist-item {
  min-height: auto;
}
.checklist-item__not-apply {
  background-color: lightgray;
}
.checklist-item__border {
  border: 1px solid black;
}
.checklist-item__icon {
  padding: 0;
  margin: 0;
  transform: rotate(45deg);
}
</style>
